export const captalizeFirstLetter = (word: string) => {
  if (!word) return undefined;
  return `${word.at(0).toUpperCase()}${word.substring(1).toLocaleLowerCase()}`;
};
